import { useMutation } from '@tanstack/react-query'
import { tokenApi } from '@pig-common/api'

export default function useRevokeToken() {
  return useMutation({
    mutationFn: () => tokenApi.revoke(),
  })
}
